import { SwitchGetByGeoLocation } from './SwitchGetByGeoLocation';
import {
  PencilOutlined,
  HomeLocationOutlined,
  NavigationOutlined,
} from '@teko/ds-icon';
import { Flex, Shape, SubTitle, Body, Button, styled } from '@teko/ds-mobile';
import React, { useState, useEffect } from 'react';
import { t } from 'i18n';
import { useDistanceTerminalContext } from 'contexts';
import { ISupermarketTerminal } from '@teko/order';

export const ModeListTerminal = () => {
  const {
    currentTerminals = [],
    currentTerminal,
    setNewTerminal,
    isLoadingGetDistanceTerminals,
    temporaryDataDistanceTerminal,
    setIsModeEnterAddress,
    isModeEnterAddress,
    isGetCurrentLocation,
  } = useDistanceTerminalContext();
  const [terminal, setTerminal] = useState<ISupermarketTerminal | undefined>(
    undefined,
  );
  const { location: locationGetDistanceTerminals } =
    temporaryDataDistanceTerminal;

  useEffect(() => {
    if (
      !!currentTerminals &&
      Array.isArray(currentTerminals) &&
      !!currentTerminals.length &&
      !isModeEnterAddress
    ) {
      setTerminal?.(
        !!currentTerminal
          ? currentTerminals.find(
              (t) => t.terminalId === currentTerminal.terminalId,
            ) || currentTerminals?.[0]
          : currentTerminals?.[0],
      );
    }
  }, [currentTerminal, currentTerminals, isModeEnterAddress]);

  return (
    <>
      {isGetCurrentLocation && <SwitchGetByGeoLocation />}
      <Shape width="100%">
        <Flex align="start" justify="space-between">
          <SubTitle level={3}>
            {isGetCurrentLocation
              ? t('Đang sử dụng vị trí hiện tại của bạn')
              : t('Địa chỉ:')}
          </SubTitle>
          <Flex
            align="center"
            onClick={() => setIsModeEnterAddress?.(!isModeEnterAddress)}
          >
            <PencilOutlined color="primary" size={16} />
            <SubTitle
              level={3}
              weight="regular"
              color="primary"
              marginLeft="s4"
            >
              {t('Thay đổi')}
            </SubTitle>
          </Flex>
        </Flex>
        {!isGetCurrentLocation && (
          <SubTitle weight="regular" width="75%">
            {locationGetDistanceTerminals?.address},{' '}
            {locationGetDistanceTerminals?.wardName},{' '}
            {locationGetDistanceTerminals?.provinceName}
          </SubTitle>
        )}
      </Shape>
      <Flex direction="column" gap="s8" width="100%">
        <SubTitle>
          {t(
            `${temporaryDataDistanceTerminal?.terminals?.length} siêu thị gần bạn:`,
          )}
        </SubTitle>
        {temporaryDataDistanceTerminal?.terminals?.map((item, index) => {
          const isChoice = terminal?.terminalId === item.terminalId;
          return (
            <Flex
              key={`${index} - ${item.terminalId} - ${item.terminalCode}`}
              padding="s8"
              border={isChoice ? '1px solid primary' : '1px solid border'}
              borderRadius="l"
              direction="column"
              gap="s4"
              onClick={() => setTerminal(item)}
              width="100%"
            >
              <Flex justify="space-between" width="100%">
                <Body textTransform="uppercase">{item.terminalName}</Body>
                <Flex gap="s4" justify="center" align="center">
                  <Body decoration="underline" color="primary">
                    {item.distance?.toFixed(2)} km
                  </Body>
                  <Flex>
                    <NavigationOutlined size={16} />
                  </Flex>
                </Flex>
              </Flex>
              <Flex gap="s8">
                <Shape>
                  <HomeLocationOutlined size={16} />
                </Shape>
                <Body level={1}>{item.fullAddress}</Body>
              </Flex>
            </Flex>
          );
        })}
      </Flex>
      <StyledButtonWrapper>
        <Button
          block
          onClick={() => {
            if (!!terminal) {
              setNewTerminal?.(terminal);
            }
          }}
          variant="primary"
          disabled={!terminal || isLoadingGetDistanceTerminals}
        >
          {t('Mua sắm ngay')}
        </Button>
      </StyledButtonWrapper>
    </>
  );
};

const StyledButtonWrapper = styled(Shape)`
  width: 100%;
  position: fixed;
  bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
`;
